/**
 * Default light theme tokens.
 * Parent apps can import, extend, or replace via the `theme` prop.
 */
export const lightTheme = {
  mode: 'light',
  colors: {
    primary: '#2D64B8',
    primaryHover: '#2557A3',
    text: '#111827',
    textSecondary: '#6B7280',
    textMuted: '#9CA3AF',
    border: '#E5E7EB',
    borderLight: '#F3F4F6',
    background: '#FFFFFF',
    surface: '#FFFFFF',
    white: '#FFFFFF',
    onPrimary: '#FFFFFF',
    activeBg: '#ECFDF5',
    activeBorder: '#A7F3D0',
    activeText: '#059669',
    inactiveBg: '#F3F4F6',
    inactiveBorder: '#D1D5DB',
    inactiveText: '#6B7280',
    link: '#2D64B8',
    divider: '#E5E7EB',
    accentBorder: '#C5D7F0',
    accentBg: '#EEF4FB',
    stepDone: '#D6E4F7',
    success: '#22C55E',
    danger: '#EF4444',
    secondaryBtn: '#D1D5DB',
    secondaryBtnHover: '#C4C9D1',
    inputBg: '#FFFFFF',
    tableHeadBg: '#EEF4FB',
    sidebarBg: '#FAFBFD',
    overlay: 'rgba(16, 24, 40, 0.06)',
  },
  radii: {
    sm: '6px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    pill: '999px',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    xxl: '32px',
  },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h1Size: '28px',
    h2Size: '16px',
    bodySize: '14px',
    labelSize: '13px',
    valueSize: '22px',
    smallSize: '13px',
  },
  shadow: {
    card: '0 1px 2px rgba(16, 24, 40, 0.04)',
    settings: '0 1px 3px rgba(16, 24, 40, 0.06)',
  },
};

/**
 * Default dark theme tokens.
 */
export const darkTheme = {
  mode: 'dark',
  colors: {
    primary: '#5B8DEF',
    primaryHover: '#7BA3F3',
    text: '#F3F4F6',
    textSecondary: '#A1A1AA',
    textMuted: '#71717A',
    border: '#3F3F46',
    borderLight: '#27272A',
    background: '#0F1115',
    surface: '#18181B',
    white: '#FFFFFF',
    onPrimary: '#FFFFFF',
    activeBg: '#052E1C',
    activeBorder: '#166534',
    activeText: '#4ADE80',
    inactiveBg: '#27272A',
    inactiveBorder: '#3F3F46',
    inactiveText: '#A1A1AA',
    link: '#7BA3F3',
    divider: '#3F3F46',
    accentBorder: '#2A3A55',
    accentBg: '#1A2333',
    stepDone: '#1E3A5F',
    success: '#22C55E',
    danger: '#F87171',
    secondaryBtn: '#3F3F46',
    secondaryBtnHover: '#52525B',
    inputBg: '#18181B',
    tableHeadBg: '#1A2333',
    sidebarBg: '#12141A',
    overlay: 'rgba(0, 0, 0, 0.35)',
  },
  radii: {
    sm: '6px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    pill: '999px',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    xxl: '32px',
  },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h1Size: '28px',
    h2Size: '16px',
    bodySize: '14px',
    labelSize: '13px',
    valueSize: '22px',
    smallSize: '13px',
  },
  shadow: {
    card: '0 1px 2px rgba(0, 0, 0, 0.35)',
    settings: '0 1px 3px rgba(0, 0, 0, 0.4)',
  },
};

/** Bundled theme file shape parents can mirror / extend. */
export const defaultThemeFile = {
  light: lightTheme,
  dark: darkTheme,
};
